var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHomeIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20 19.9623V8.91089L12 4.02987L4 8.91089V19.9623H8V17.1659C8 16.0871 8.42143 15.0526 9.17157 14.2898C9.92172 13.5269 10.9391 13.0984 12 13.0984C13.0609 13.0984 14.0783 13.5269 14.8284 14.2898C15.5786 15.0526 16 16.0871 16 17.1659V19.9623H20ZM14 21.9961V17.1659C14 16.6265 13.7893 16.1092 13.4142 15.7278C13.0391 15.3464 12.5304 15.1322 12 15.1322C11.4696 15.1322 10.9609 15.3464 10.5858 15.7278C10.2107 16.1092 10 16.6265 10 17.1659V21.9961H4C3.46957 21.9961 2.96086 21.7818 2.58579 21.4004C2.21071 21.019 2 20.5017 2 19.9623V8.91089C2 8.55969 2.08943 8.21447 2.25959 7.90886C2.42976 7.60324 2.67485 7.34764 2.971 7.16694L10.971 2.28592C11.2818 2.09627 11.6375 1.99609 12 1.99609C12.3625 1.99609 12.7182 2.09627 13.029 2.28592L21.029 7.16694C21.3252 7.34764 21.5702 7.60324 21.7404 7.90886C21.9106 8.21447 22 8.55969 22 8.91089V19.9623C22 20.5017 21.7893 21.019 21.4142 21.4004C21.0391 21.7818 20.5304 21.9961 20 21.9961H14Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHomeIcon);
export default __webpack_public_path__ + "static/media/home-icon.ba8a00afefd2416c44c6b1b1882b98b4.svg";
export { ForwardRef as ReactComponent };